import Sample from './SampleDef';

export default { Sample };
